import styled from "styled-components";
import { theme } from "../../styles/theme";

export const CardLink = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 120px;
  gap: 23px;
  padding: 27px 53px 27px 28px;;
  background: ${({ background}) => background};
  border-radius: 15px;
  opacity: 1;
  cursor: pointer;
`;

export const IconCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  background: ${theme.colors.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000000A;
  border-radius: 10px;
  opacity: 1;
  flex-shrink: 0;

  img {
    width: 60%;
    height: 60%;
    object-fit: contain;
    display: block;
  }
`;

export const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  background-image: repeating-linear-gradient(
    to right,
    ${theme.colors.light3} 0,
    ${theme.colors.light3} 5px,
    transparent 5px,
    transparent 10px
  );
  margin-top: 21px;
  margin-bottom: 22px;
`;